import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";

import {
  HomeSkeleton,
  ProductTilesWrapper,
  SearchTilesWrapper,
} from "@faire/retailer/components/GhostLoading/HomeSkeleton";

export const ExplorePageLayoutSkeleton: React.FC = () => {
  return (
    <StyledHomeSkeletonWrapper>
      <HomeSkeleton />
    </StyledHomeSkeletonWrapper>
  );
};

const StyledHomeSkeletonWrapper = styled.div`
  padding: 0;

  & ${SearchTilesWrapper}, ${ProductTilesWrapper} {
    padding: ${getSpacing("3x", 0)};
  }
`;
